import styled from "styled-components";
import { Button, Modal, Typography } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/core-labels";

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  margin-top: 48px;
  margin-bottom: 24px;
`;

export interface UnsavedChangesModalProps {
  isOpen: boolean;
  onLeave: () => void;
  onStay: () => void;
}

export const UnsavedChangesModal = ({
  isOpen,
  onLeave,
  onStay
}: UnsavedChangesModalProps) => (
  <Modal
    header={String(Locale.getText("FEEMANAGER_UNSAVED_TITLE"))}
    show={isOpen}
    size="small"
    onHide={onStay}
  >
    <Typography variant={"body-md"}>
      {String(Locale.getText("FEEMANAGER_UNSAVED_BODY"))}
    </Typography>
    <ButtonGroup>
      <Button
        analyticsConfiguration={{
          eventName: "Fee Manager Unsaved Changes Stay",
          eventProperties: undefined
        }}
        buttonStyle="secondary"
        onClick={onStay}
      >
        {String(Locale.getText("FEEMANAGER_UNSAVED_STAY"))}
      </Button>
      <Button
        analyticsConfiguration={{
          eventName: "Fee Manager Unsaved Changes Leave",
          eventProperties: undefined
        }}
        buttonStyle="primary"
        onClick={onLeave}
      >
        {String(Locale.getText("FEEMANAGER_UNSAVED_LEAVE"))}
      </Button>
    </ButtonGroup>
  </Modal>
);
